import React from "react";
import StatementList from "./StatementList";
import MenuBar from "./MenuBar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./Login";
import SignUp from "./SignUp";
import Donate from "./Donate";
import About from "./About";



const App = () => {
  return (
    <Router>
    <div className="bg-customFulBlue min-h-screen">
    {/* Menu Bar */}
    <MenuBar />

    {/* Main Content */}
    <div className="max-w-4xl mx-auto p-6">



      <Routes>
        <Route path="/about" element={<About />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/" element={<StatementList />} />
      </Routes>
      </div>
      </div>

    </Router>

  );
};


export default App;
